module.exports = __webpack_public_path__ + "img/sort.b8645f0c.svg";